import { User } from "./User"

export type Person =
  { id: number
  , email: string
  , firstName: string
  , lastName: string
  , phoneNumber: string
  , crmNotes: string
  , createdAt: string
  , user: User
  }

export type PersonEvent =
  { id: number
  , category: PersonEventCategory
  , eventName: string
  , properties: Object
  , timestamp: string
  , crmNotes: string
  , associatedRecordType?: string
  , associatedRecordId?: number
  , updatedAt: string
  }

// Keep this aligned with the PersonEvent::Category class in person_event.rb
// Also, if you're making changes here, you'll also want to update the associated icons in EventCard.tsx
export enum PersonEventCategory
  { CustomerSupport = 'customer-support'
  , Demo = 'demo'
  , TransactionalEmail = 'transactional-email'
  , CampaignEmail = 'campaign-email'
  , BroadcastEmail = 'broadcast-email'
  , Subscription = 'subscription'
  , ProjectRequest = 'project-request'
  , HourlyContract = 'hourly-contract'
  , LeadMagnet = 'lead-magnet'
  , Livestream = 'livestream'
  , Meeting = 'meeting'
  , Revenue = 'revenue'
  , PaymentMethod = 'payment-method'
  }
